import { useState, useEffect } from "react";
import { Form, message } from "antd";
import {
  fetchProjectData,
  toggleResubmission,
} from "PlatForms/OrgLMS/Services/MentorServices/TrainingDetailService";
import dayjs from "dayjs";
import axios from "axios";

export const useTrainingDetail = (trainingId) => {
  const [projectData, setProjectData] = useState(null);
  const [courseId, setCourseId] = useState();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [contentType, setContentType] = useState(null);
  const [contentItems, setContentItems] = useState([]);
  const [loadingContent, setLoadingContent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [updating, setUpdating] = useState(null);
  //   const [updating, setUpdating] = useState(false);

  const fetchProjects = async () => {
    try {
      const data = await fetchProjectData(trainingId, token);
      setProjectData(data);
      setCourseId(data.courseId);
    } catch (error) {
      message.error("Error fetching project data");
    } finally {
      setLoading(false);
    }
  };

  const handleToggleResubmission = async (id, currentStatus) => {
    setUpdating(id);
    try {
      await toggleResubmission(id, token);
      message.success(`Resubmission ${currentStatus ? "disabled" : "enabled"} successfully!`);
      setProjectData((prevData) => ({
        ...prevData,
        tasks: prevData.tasks.map((task) =>
          task.id === id ? { ...task, enableSubmission: !currentStatus } : task
        ),
      }));
    } catch (error) {
      console.error("Toggle resubmission error:", error);
      message.error("Failed to toggle resubmission. Please try again.");
    } finally {
      setUpdating(null);
    }
  };

  const fetchContentItems = async (type) => {
    try {
      setLoadingContent(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Library/Get-Course-Files?courseId=${courseId}&type=${type}`,
        {
          headers: {
            accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setContentItems(response.data);
    } catch (error) {
      message.error("Failed to fetch content items");
      console.error("Error fetching content items:", error);
    } finally {
      setLoadingContent(false);
    }
  };

  useEffect(() => {
    if (contentType) {
      fetchContentItems(contentType);
    }
  }, [contentType]);

  const handleOk = async () => {
    try {
      setSubmitting(true);
      const values = await form.validateFields();

      const payload = {
        memberId: values.memberId,
        trainingId: parseInt(trainingId),
        courseFileId: values.contentId,
        title: values.title,
        deadline: values.deadline.toISOString(),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Training/Create-Task`,
        payload,
        {
          headers: {
            accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      message.success("Task assigned successfully");
      setIsModalVisible(false);
      form.resetFields();
      setContentType(null);
      setContentItems([]);
      fetchProjects();
    } catch (error) {
      // Only show error message if it's not a validation error
      if (!error.errorFields) {
        console.error("Error assigning task:", error);
        message.error(error.response?.data || "Failed to assign task");
      }
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
    setContentType(null);
    setContentItems([]);
  };

  const handleContentTypeChange = (value) => {
    setContentType(value);
    form.setFieldsValue({ contentId: undefined });
  };

  const disabledDate = (current) => {
    return current && current <= dayjs().startOf("day");
  };

  useEffect(() => {
    fetchProjects();
  }, [trainingId]);

  return {
    isModalVisible,
    disabledDate,
    handleContentTypeChange,
    handleCancel,
    handleOk,
    loadingContent,
    submitting,
    contentItems,
    projectData,
    loading,
    contentType,
    form,
    setIsModalVisible,
    updating,
    handleToggleResubmission,
    fetchProjects,
  };
};
